/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import Lottie from 'react-lottie';

import { makeStyles } from '@material-ui/core';

import animationData from './data.json';

export interface PreLoaderLogoProps {
    size: 'small' | 'medium';
}

export function PreLoaderLogo(props: PreLoaderLogoProps): React.FC {
    const { size } = props;

    const useStyles = makeStyles(() => ({
        preloader: {
            position: 'absolute',
            height: '70px',
            width: '70px'
        }
    }));

    const classes = useStyles();

    const loaderSize = size === 'small' ? '48px' : '64px';

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className={classes.preloader} id={'backdrop-loader'} data-testid='backdrop-loader'>
            <Lottie options={defaultOptions} height={loaderSize} width={loaderSize} />
        </div>
    );
}
